import { type FC } from 'react';

import { Navigate } from 'react-router-dom';

interface IProps {
  canAccessView: boolean;
  noAccessRedirectUrl: string;
  render: () => JSX.Element;
}

export const RestrictedAccessRoute: FC<IProps> = ({ canAccessView, noAccessRedirectUrl, render }) => {
  if (!canAccessView) {
    return <Navigate to={noAccessRedirectUrl} replace />;
  }

  return <>{render()}</>;
};
